import React, { useEffect, useState } from 'react'
import Pagination from '../../common/Pagination';
import Table from './Table';
import { Link } from 'react-router-dom';
import Header from '../../common/Header';
import { useAdminContext } from '../../../context/adminContext';
import { debounce } from 'lodash';
import { addNewsToCarouselApi, getAllAddedCarouselNewsApi, getAllUnCarouselNewsApi, removeNewsFromCarouselApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import AddCrouselModal from '../../common/AddCrouselModal';
import { useFormik } from 'formik';
import ModalVideo from './ModalVideo';
import { manageCarouselIntialValue, manageCarouselValidationSchema } from '../../common/Validation';
import CarouselTable from './CarouselTable';
import RemoveModal from '../../common/RemoveModal';

function ManageNewsCarousel() {

  const { adminDetail } = useAdminContext();
  let [selectedPage, setSelectPage] = useState(0);
  const [news, setNews] = useState([]);
  const [removeData, setRemoveData] = useState(null);
  const [tableSpin, setTableSpin] = useState(true);
  const [newsData, setNewsData] = useState({});
  const carouselModalId = "carouselModalID";
  const removeCarouselModalId = "removeCarouselModalId"
  const [carouselOptions, setCarouselOptions] = useState([]);
  const [modalUpdate, setModalUpdate] = useState({
    id: "",
    status: false,
    type: ""
  })

  const [page, setPage] = useState(0);
  let [type, setType] = useState("article")
  const [searchText, setSearchText] = useState("");
  const limit = 10;

  const getAllAddedCarouselNews = async () => {
    setTableSpin(false)
    const res = await getAllAddedCarouselNewsApi(limit, selectedPage + 1, searchText, type)
    if (res.status === 200) {
      const totalData = res.data?.totalData
      setPage(Math.ceil(totalData / limit));
      setNews(res.data?.data)
      setTableSpin(true)
    }
  }

  const getAllUnCarouselNews =  async () => {
    const res = await getAllUnCarouselNewsApi('', type)
    if(res.status === 200) {
      setCarouselOptions(res.data?.data?.map((ele, index) => {
        return {
          label: ele?.newsTitle,
          value: ele
        }
      }))

    }

  }

  const onChange = async (e) => {
    let search = e.target.value;
    setTableSpin(false);
    setSearchText(search)
    const res = await getAllAddedCarouselNewsApi(limit, 1, search, type);
    if (res.status === 200) {
      
      setNews(res.data?.data);
      const totalData = res.data?.totalData
      setPage(Math.ceil(totalData / limit));
      setSelectPage(0)
      setTableSpin(true);
    }
  };

  const debouncedOnChange = debounce(onChange, 500);

  // const removeHandler = async (e) => {
  //   e.preventDefault()
  //   try {
  //     if (removeData._id) {
  //       const res = await deleteNewsByIdApi(removeData?._id);
  //       if (res.status === 200) {
  //         toast.success(res.data?.message)
  //         getAllAddedCarouselNews(selectedPage, type);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  useEffect(() => {
    getAllAddedCarouselNews();

  }, [])

  const handlePageClick = (event) => {
    selectedPage = event.selected
    setSelectPage(event.selected);
    getAllAddedCarouselNews(event.selected, type);
  };

  const handleTab = (ele, t) => {
    ele.preventDefault();
    selectedPage = 0;
    setSelectPage(0);
    type=t
    setType(t)
    getAllAddedCarouselNews();
  }

  const addCarousel = async (values) => {
    try {
      
      document.getElementById(carouselModalId).click()
      const res = await addNewsToCarouselApi({id:values.id?._id, type});
      if (res.status === 200) {
        toast.success(res.data?.message)
        getAllAddedCarouselNews(selectedPage, type);
      }
    } catch (error) {
      toast.error("Something went wrong")
    }
  }

  const handleRemoveData = async (data) => {

    try {
      document.getElementById(removeCarouselModalId).click();
      const res = await removeNewsFromCarouselApi({ _id: removeData })
      if (res.status === 200) {
        getAllAddedCarouselNews(selectedPage, type);

        toast.success(res.data?.message)
      }
    } catch (error) {
      toast.error("Something went wrong")
    }
  }

  const carouselFormik = useFormik({
    initialValues: manageCarouselIntialValue,
    onSubmit: addCarousel,
    validationSchema:manageCarouselValidationSchema
  })

  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title={<>Info &amp; News</>} />
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard" >
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <Link to="/news" className="breadcrumb-item active" aria-current="page">
                  Info &amp; News
                </Link>
                <li className="breadcrumb-item active" aria-current="page">
                  Carousel
                </li>
              </ol>
            </nav>
            <div className="d-flex justify-content-end mb-4 flex-wrap">
              <div className='d-flex gap-3 justify-content-end align-items-center' style={{ display: "-webkit-inline-box" }}>
                <div className="btn-custom" data-bs-toggle="modal" data-bs-target={`#${carouselModalId}`} onClick={() => { carouselFormik.resetForm(); getAllUnCarouselNews()}}>
                  Add
                </div>
                <div className="position-relative">
                  <input
                    className="form-search me-3"
                    type="search"
                    name=""
                    onChange={debouncedOnChange}
                    placeholder="Search"
                  />
                  <img
                    className="users-search"
                    src="/images/Icon feather-search.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <hr />

          <div className="card p-3">
              <CarouselTable
                status="Official"
                selectedPage={selectedPage}
                limit={limit}
                tableData={news}
                setTableData={setNews}
                setRemoveData={setRemoveData}
                tableSpin={tableSpin}
                setModalUpdate={setModalUpdate}
                setNewsData={setNewsData}
                carouselFormik={carouselFormik}
                carouselModalId={carouselModalId}
                resetTableData={getAllAddedCarouselNews}
              />
          </div>
          </div>
          <div className="d-flex justify-content-center">
            {news?.length > limit ? <Pagination
              clickHandler={handlePageClick}
              page={page}
              selectedPage={selectedPage}
            /> : null}
          </div>
        </div>
      </div>
      <AddCrouselModal modalId={carouselModalId} formik={carouselFormik} title="Select news" options={carouselOptions} currentValue={carouselFormik?.values?.id ? { label: carouselFormik?.values?.id?.newsTitle, value: carouselFormik?.values?.id } : null } />
      <ModalVideo
        newsData={newsData}
        setNewsData={setNewsData}
      />

      <RemoveModal removeHandler={handleRemoveData} modalId={removeCarouselModalId} message={<>Are you sure you want to<br /> remove this?</>} />

    </>
  )
}

export default ManageNewsCarousel